module.exports = __webpack_public_path__ + "media/images/views/dashboard/star-2-0d11083bdb0c481435f764fb0b8cde60.svg";